import React from "react";
import { connect } from "react-redux";
import { change, submit } from "redux-form";
import styles from "./dashboard/Styles";
import moment from "moment";
import {
  GET_ONE,
  GET_LIST,
  UPDATE,
  CREATE,
  SimpleForm,
  FunctionField,
  Responsive,
  SaveButton,
  showNotification
} from "react-admin";
import { LinearProgress, CircularProgress, Paper, Select, MenuItem, Card, CardContent, Typography, Grid, Toolbar, InputLabel, FormControl, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import dataProviderFactory from "../dataProvider";
import { head, prop, path, map, find, propEq, assoc, sort, pluck, isEmpty, all, isNil, reduce } from "ramda";

class LocationRecommendedBikesEdit extends React.Component {
  state = {
    vehicleModels: null,
    modelId: 0,
    loading: true,
    recommendedBikes: null,
    saving: false,
  }

  mergeWithDefaultRecommendedBikeNumbers = (locationId, vehicleModelId, existingNumbers) => {
    const months = moment.months();
    
    return months.map((month, index) => {
      const existingRecord = find(propEq('month_index', index), existingNumbers);
      return existingRecord 
        ? existingRecord 
        : ({
          location_id: locationId,
          vehicle_model_id: vehicleModelId,
          month_index: index,
          upper: 0,
          lower: 0,
        })
    });
  };

  async getLocationRecommendedBikes() {
    const { record } = this.props;
    const { modelId } = this.state;
    const locationId = prop('id', record);
    const dataProvider = await dataProviderFactory("rest");
    const recommendedBikes = await dataProvider(GET_LIST, "location_recommended_bikes", {
      filter: {
        model_id: modelId,
        location_id: locationId,
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "month_index", order: "ASC" }
    });

    const mergedRecommendedBikes = this.mergeWithDefaultRecommendedBikeNumbers(locationId, modelId, recommendedBikes.data);
    this.setState({ recommendedBikes: mergedRecommendedBikes });
  }

  async getVehicleModels() {
    const dataProvider = await dataProviderFactory("rest");
    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_3" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    this.setState({ 
      vehicleModels: vehicleModels.data,
      modelId: prop("id", head(vehicleModels.data)),
    });
  }

  componentDidMount() {
    this.getVehicleModels();
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { modelId: prevModelId } = prevState;
    const { modelId } = this.state;

    if (modelId !== prevModelId) {
      this.getLocationRecommendedBikes();
    }
  }

  buildModelsMenuItems(models) {
    return map(model => {
      return (
        <MenuItem key={model.id} value={model.id}>
          {model.model_name}
        </MenuItem>
      );
    }, models);
  }


  handleChangeValues(event, index, property) {
    const { recommendedBikes } = this.state;
  
    recommendedBikes[index] = assoc(property, event.target.value, recommendedBikes[index]);

    this.setState({ 
      recommendedBikes,
    });
  }

  buildMonthValuesInputs() {
    const { recommendedBikes, saving } = this.state;
    const months = moment.months();

    return months.map((month, index) => {
      const recommendedNumbers = recommendedBikes[index];
      
      return (
        <React.Fragment>
          <div style={{display: "inline-block", minWidth: '100px'}}>
            <span>{month}</span>
          </div>
          <TextField
            id={`lower-${index}-number`}
            label="Lower"
            value={recommendedNumbers.lower}
            onChange={(e) => this.handleChangeValues(e, index, 'lower')}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            margin="dense"
            style={{width: '100px', marginRight: '15px'}}
            disabled={saving}
          />
          <TextField
            id={`upper-${index}-number`}
            label="Upper"
            value={recommendedNumbers.upper}
            onChange={(e) => this.handleChangeValues(e, index, 'upper')}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            margin="dense"
            style={{width: '100px'}}
            disabled={saving}
          />
          <br />
        </React.Fragment>
      );
    });
  }

  async handleSubmit() {
    const dataProvider = await dataProviderFactory("rest");
    const { recommendedBikes, modelId } = this.state;
    const { showNotification, record } = this.props;
    const locationId = prop('id', record);

    const updateOrCreatePromises = reduce((promises, bikeValues) => {
      const bodyRequest = {};
      
      bodyRequest.data = bikeValues;

      if (bikeValues.id) {
        bodyRequest.id = bikeValues.id;
        return promises.concat([dataProvider(UPDATE, "location_recommended_bikes", bodyRequest)]);
      } else {
        // Do not create empty records
        if (Number(bikeValues.lower) !== 0 || Number(bikeValues.upper) !== 0) {
          return promises.concat([dataProvider(CREATE, "location_recommended_bikes", bodyRequest)]);
        }
      }
      return promises;

    }, [], recommendedBikes);

    // If there is nothing to update/create
    if (isEmpty(updateOrCreatePromises)) {
      this.setState({ saving: false });
      return;
    }

    Promise.all(updateOrCreatePromises)
      .then((values) => {
        const newValues = this.mergeWithDefaultRecommendedBikeNumbers(locationId, modelId, pluck('data', values))
        this.setState({ recommendedBikes: newValues, saving: false });
        showNotification("Updated bike numbers successfully", "error");
      })
      .catch(error => {
        this.setState({ saving: false });
        showNotification(error.message, "error");
      });      
  }

  handleChangeModel = event => {
    this.setState({ 
      [event.target.name]: event.target.value,
      recommendedBikes: null,
    });
  };

  handleSaveClick() {
    this.handleSubmit();
    this.setState({ saving: true});
  }

  render() {
    const { vehicleModels, modelId, recommendedBikes, saving } = this.state;
    const { id, record, resource} = this.props;
    
    return (
      <React.Fragment>
        <Grid container spacing={16} direction="column">
          <Grid item>
            { vehicleModels && 
              <FormControl margin="normal" style={{width: '150px'}}>
                <InputLabel shrink id="modelId-label">
                  Vehicle Model
                </InputLabel>
                <Select
                  value={modelId}
                  disabled={saving}
                  onChange={this.handleChangeModel}
                  inputProps={{
                    name: "modelId",
                    id: "model"
                  }}
                >
                  {this.buildModelsMenuItems(vehicleModels)}
                </Select>
              </FormControl>
            }
          </Grid>
          { recommendedBikes && 
            <React.Fragment>
              <Grid item>
                {this.buildMonthValuesInputs()}
              </Grid>
              <Grid item>
                <SaveButton
                  onClick={() => this.handleSaveClick()}
                  disabled={saving}
                  saving={saving}
                  label="Save Bike Numbers"
                />
              </Grid>
            </React.Fragment>}
        </Grid>
        {(!recommendedBikes || !vehicleModels) &&
          <Grid container justify="center" style={{padding: "30px"}}>
            <CircularProgress />
          </Grid>
        }
      </React.Fragment>
      
    );
  }
}

const mapStateToProps = state => ({
  state: state
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(LocationRecommendedBikesEdit)
);


// WEBPACK FOOTER //
// ./src/components/LocationRecommendedBikesEdit.js